import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons/index.js";
import { GlobalConfiguration } from "../../../../utils/configurationProvider.js";
import useMultiSelect from "../../../../utils/useMultiSelect.js";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import AccountNumberWithBank from "../../../_utils/CommonViewAllCard/CardSubComponent/AccountNumberWithBank";
import TextWithCTA from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithCTA";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";

const ScheduleInternalTransactionMultiApprovalCards = ({
  data,
  selectedCardIds,
  setSelectedCardIds,
  selectedSendTransactions,
  setSelectedSendTransactions,
  setIsAdditionalPopupOpen,
  setInternalAccDetailPopOpen,
  setInternalScheduleId,
  setInternalAccId,
  isSidebarOpenpop,
  filterRef,
}) => {
  const navigate = useNavigate();
  const services = useSelector((state) => state.refreshToken?.services || []);
  const { handleSingleSelect: handleMultiSingleSelect } = useMultiSelect();
  const MAX_SELECTION_SIZE = GlobalConfiguration.categorymaxLength;

  //functions
  const getFormattedFrequency = (txn) => {
    const startDate = txn?.transaction_start_date;
    const frequency = txn?.frequency?.toLowerCase();

    if (!startDate || !frequency) return "";

    const dateObj = new Date(startDate);
    const day = dateObj.getDate();
    const weekday = dateObj.toLocaleString("en-IN", { weekday: "short" });
    const rawMonth = dateObj.toLocaleString("en-IN", { month: "short" });
    const month = rawMonth.charAt(0).toUpperCase() + rawMonth.slice(1);

    const formatDate = (d) => `${d.getDate()} ${month}`;

    switch (frequency) {
      case "weekly":
        return `on ${weekday}`;
      case "monthly":
        return `on ${day}`;
      case "yearly":
      case "once":
        return `on ${formatDate(dateObj)}`;
      default:
        return "";
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--settled)";
      case "denied":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--settled)";
    }
  };

  const formattedFrequencyText = () => {
    const freq = data?.frequency?.toLowerCase();
    const formattedFreq =
      freq === "half_yearly"
        ? "Half yearly"
        : freq?.charAt(0).toUpperCase() + freq?.slice(1);
    const formattedDate = getFormattedFrequency(data);

    return formattedDate ? `${formattedFreq}, ${formattedDate}` : formattedFreq;
  };

  return (
    <>
      <CardContainer
        filterRef={filterRef}
        isDisabled={
          data?.internal_account_approval_status === "pending" ||
          isSidebarOpenpop
            ? true
            : false
        }
        varaint="overlay"
        isSelected={selectedCardIds?.includes(data?.txn_id)}
        onClickHandler={() => {
          if (data?.internal_account_approval_status !== "pending") {
            handleMultiSingleSelect(
              selectedSendTransactions,
              setSelectedSendTransactions,
              MAX_SELECTION_SIZE,
              { ...data, id: data?.txn_id },
            );
          }
        }}
      >
        <card-body>
          <TextWithIcon
            type="Text"
            textColor="var(--text-primary)"
            fontWeight="normal"
            text={data?.scheduled_name}
            subText="Schedule name"
            iconComponentArray={[
              ...(data?.confidential_transaction === "Y"
                ? [
                    {
                      icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                      title: "confidential",
                      isDisabled: false,
                    },
                  ]
                : []),

              {
                icon: selectedCardIds?.includes(data?.txn_id)
                  ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                  : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                isDisabled: false,
              },
            ]}
          />

          <TextWithIcon
            type={
              data.internal_account_approval_status === "pending"
                ? "Text"
                : "Amount"
            }
            fontWeight={"semibold"}
            text={
              data.internal_account_approval_status === "pending"
                ? "Account approval pending"
                : data?.amount
            }
            subText={
              data?.internal_account_approval_status === "pending" ||
              data?.internal_account_approval_status === "rejected"
                ? "Account status"
                : "Transaction amount"
            }
            textColor={getStatusColor(data.internal_account_approval_status)}
          />

          <AccountNumberWithBank
            sourceAccNo={data?.owner_account_bank_acc_no}
            destinationAccNo={data?.internal_account_bank_acc_no}
            destinationIfsc={data?.internal_account_ifsc_code}
            sourceIfsc={data?.owner_account_ifsc_code}
          />

          <TextWithCTA
            btnText={
              data?.internal_account_approval_status === "pending"
                ? "Approve account"
                : "Additional details"
            }
            enabledBgColor={"var(--text-primary)"}
            enabledTextColor={"var(--primary-bg)"}
            // if (data?.internal_account_approval_status === "pending") {
            //   setInternalAccDetailPopOpen(true);
            //   setInternalAccId(data?.internal_account_id);
            // } else {
            //   setIsAdditionalPopupOpen("Additional details");
            //   setInternalScheduleId(data?.txn_id);
            // }
            handleFunction={(e) => {
              e.stopPropagation();

              if (data?.internal_account_approval_status === "pending") {
                const hasService =
                  (services.includes("IAAccount") &&
                    services.includes("IVAccount")) ||
                  services.includes("Admin");

                if (!hasService) {
                  navigate("/feature_not_assigned", {
                    state: {
                      unavailableService: ["IAAccount", "IVAccount"],
                    },
                  });
                  return;
                }

                setInternalAccDetailPopOpen(true);
                setInternalAccId(data?.internal_account_id);
              } else {
                setIsAdditionalPopupOpen("Additional details");
                setInternalScheduleId(data?.txn_id);
              }
            }}
            icon={ICONS?.ARROW_RIGHT_WHITE}
            isDisabled={isSidebarOpenpop ? true : false}
            text={formattedFrequencyText()}
            subText="Frequency"
          />
        </card-body>
        <card-hover>
          <TextWithIcon
            text={data?.labels?.join(", ") || "No labels assigned"}
            fontWeight={"normal"}
            textColor={"var(--text-primary)"}
            iconComponentArray={[
              {
                icon: ICONS?.LABEL,
              },
            ]}
          />
        </card-hover>
      </CardContainer>
    </>
  );
};

export default ScheduleInternalTransactionMultiApprovalCards;
